import request from '@/utils/request'

// 分页查询户型信息
export function getPageList(params) {
  return request({
    url: '/hrApi/houseType',
    method: 'get',
    params: params
  })
}

// 获取户型列表
export function getList(params) {
  return request({
    url: '/hrApi/houseType/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑户型
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/houseType',
    method: 'post',
    data: data
  })
}

// 删除户型
export function deleteData(id) {
  return request({
    url: '/hrApi/houseType/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/houseType.js